/* The optional store badge starts after the main page has loaded and painted. */
(function () {
  'use strict';
  var configElement = document.querySelector('[data-merchant-widget-config]');
  if (!configElement || window.shipabobMerchantWidgetScheduled) return;
  var config;
  try { config = JSON.parse(configElement.textContent); } catch (error) { return; }
  if (!/^\d+$/.test(String(config.merchant_id))) return;
  window.shipabobMerchantWidgetScheduled = true;
  var loaded = document.readyState === 'complete';
  var requested = false;
  var scheduled = false;
  var timer;

  function start() {
    var source = 'https://www.gstatic.com/shopping/merchant/merchantwidget.js';
    if (document.querySelector('script[src="' + source + '"]')) return;
    var script = document.createElement('script');
    script.src = source;
    script.async = true;
    script.addEventListener('load', function () {
      if (window.merchantwidget && typeof window.merchantwidget.start === 'function') {
        window.merchantwidget.start(config);
      }
    }, { once: true });
    document.head.appendChild(script);
  }

  function requestStart() {
    requested = true;
    if (!loaded || scheduled) return;
    scheduled = true;
    window.clearTimeout(timer);
    document.removeEventListener('pointerdown', requestStart);
    document.removeEventListener('keydown', requestStart);
    window.removeEventListener('scroll', requestStart);
    if ('requestIdleCallback' in window) window.requestIdleCallback(start, { timeout: 2000 });
    else start();
  }

  function afterLoad() {
    loaded = true;
    if (requested) requestStart();
    // Readers who do not interact still receive the badge after the initial load settles.
    else timer = window.setTimeout(requestStart, 5000);
  }

  document.addEventListener('pointerdown', requestStart, { passive: true, once: true });
  document.addEventListener('keydown', requestStart, { once: true });
  window.addEventListener('scroll', requestStart, { passive: true, once: true });
  if (loaded) afterLoad();
  else window.addEventListener('load', afterLoad, { once: true });
})();
